require( 'slick-carousel-latest' );
( function ( $ ) {
	$( function () {
		if ( $( '[data-slick]' ).length ) {
			$( '[data-slick]' ).not( '.slick-initialized' ).slick();
		}
	} );
} )( jQuery );
